import React from 'react'
import { createPortal } from 'react-dom'

const GiftAidModalButtons = ({ onConfirm }) => {
  return createPortal(
    <div className="d-flex flex-column flex-md-row gap-2">
      <button
        type="button"
        className="btn btn-primary"
        data-bs-dismiss="modal"
        onClick={onConfirm}
      >
        I agree and confirm
      </button>
      <button
        type="button"
        className="btn btn-light"
        data-bs-dismiss="modal"
      >
        Continue without Gift Aid
      </button>
    </div>,
    document.getElementById('giftAidModalButtons')
  )
}

export default GiftAidModalButtons 